<template>
  <div class="public-shop member-auth-page">
    <header class="shop-header member-auth-hero" :style="{ background: themeGradient }">
      <div class="container member-auth-hero-inner">
        <router-link :to="shopPath('/member/login')" class="member-auth-back">
          <i class="fas fa-arrow-left"></i> Kembali ke Login
        </router-link>
        <div class="member-auth-brand" v-if="shop">
          <img v-if="shop.logo_url" :src="shop.logo_url" alt="" class="member-auth-logo">
          <div v-else class="member-auth-logo-placeholder">
            <i class="fas fa-store"></i>
          </div>
          <div>
            <h1 class="member-auth-shop-name text-white">{{ shop.name }}</h1>
            <small class="text-white-50">Buat Password Baru</small>
          </div>
        </div>
      </div>
    </header>

    <div class="container member-auth-wrap">
      <div class="row justify-content-center">
        <div class="col-md-5 col-lg-4">
          <div class="member-auth-card shop-card p-4 p-md-5">
            <div class="member-auth-card-header mb-4">
              <div class="member-auth-icon-wrap">
                <i class="fas fa-lock"></i>
              </div>
              <h2 class="member-auth-title">Buat Password Baru</h2>
              <p class="member-auth-subtitle">Masukkan password baru untuk akun member Anda</p>
            </div>

            <div v-if="!token" class="member-alert member-alert-warning">
              <i class="fas fa-exclamation-triangle"></i>
              <span>Link reset tidak valid. Minta link baru dari halaman lupa password.</span>
            </div>
            <div v-else-if="success" class="member-alert member-alert-success">
              <i class="fas fa-check-circle"></i>
              <span>{{ success }}</span>
            </div>
            <div v-if="error" class="member-alert member-alert-danger">
              <i class="fas fa-exclamation-circle"></i>
              <span>{{ error }}</span>
            </div>

            <form v-if="token && !success" @submit.prevent="submit">
              <div class="member-form-group">
                <label class="member-form-label">Password Baru</label>
                <div class="member-input-group">
                  <input
                    v-model="password"
                    :type="showPass ? 'text' : 'password'"
                    class="member-form-input"
                    placeholder="Min 6 karakter"
                    required
                    minlength="6"
                    :disabled="loading"
                  >
                  <button type="button" class="member-input-toggle" @click="showPass = !showPass" tabindex="-1">
                    <i :class="showPass ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                  </button>
                </div>
              </div>
              <div class="member-form-group">
                <label class="member-form-label">Konfirmasi Password</label>
                <div class="member-input-group">
                  <input
                    v-model="confirm"
                    :type="showConfirm ? 'text' : 'password'"
                    class="member-form-input"
                    placeholder="Ulangi password"
                    required
                    minlength="6"
                    :disabled="loading"
                  >
                  <button type="button" class="member-input-toggle" @click="showConfirm = !showConfirm" tabindex="-1">
                    <i :class="showConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                  </button>
                </div>
              </div>
              <button type="submit" class="member-btn-primary" :disabled="loading">
                <span v-if="loading"><i class="fas fa-spinner fa-spin"></i> Menyimpan...</span>
                <span v-else><i class="fas fa-save mr-1"></i> Simpan Password</span>
              </button>
            </form>

            <div v-if="success" class="text-center mt-3">
              <router-link :to="shopPath('/member/login')" class="member-btn-primary d-inline-block text-center" style="text-decoration:none;">
                <i class="fas fa-sign-in-alt mr-1"></i> Login Sekarang
              </router-link>
            </div>

            <div v-if="!token" class="member-footer-link">
              <router-link :to="shopPath('/member/forgot-password')" class="member-link">
                Minta link reset baru
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import publicShopPaths from './public_shop_paths';
import { applyShopTheme, shopHeaderBackground, shopPublicMixin } from '@/components/shop_public/shop_public_utils';
import '@/components/shop_public/shop_public.css';
import '@/components/shop_public/member_portal.css';

export default {
  mixins: [publicShopPaths, shopPublicMixin],
  data() {
    return {
      shop: null,
      password: '',
      confirm: '',
      showPass: false,
      showConfirm: false,
      loading: false,
      error: '',
      success: '',
    };
  },
  computed: {
    themeGradient() {
      return shopHeaderBackground(this.shop);
    },
    token() {
      return this.$route.query.token || '';
    },
  },
  async mounted() {
    if (this.onCustomDomain) {
      await this.$store.dispatch('public_shop/public_get_shop_by_domain');
    }
    const r = await this.$store.dispatch('public_shop/public_get_shop', this.effectiveSlug);
    this.shop = r.data.data.shop;
    applyShopTheme(this.shop);
  },
  methods: {
    async submit() {
      if (this.password !== this.confirm) {
        this.error = 'Konfirmasi password tidak cocok.';
        return;
      }
      this.loading = true;
      this.error = '';
      try {
        const r = await this.$store.dispatch('public_shop/member_reset_password', {
          slug: this.effectiveSlug,
          token: this.token,
          password: this.password,
        });
        this.success = r.data.message || 'Password berhasil diubah.';
      } catch (e) {
        this.error = e.response?.data?.message || 'Gagal mengubah password.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
